<a (click)="goToSettings($event)"
   [ngStyle]="{cursor: disableGoingToSettings() ? 'auto' : 'pointer'}"
   class="footer">
    <div class="footer__balance">ENTRIES:
        <span [class.is-blurred]="!isUserLogged()">{{getEntries()}}</span>
    </div>
    <a (click)="goToTerms()" class="footer__terms">Terms and Conditions</a>
    <button class="footer__scroll-btn">
        <img src="../../../assets/images/games-playground/arrow-block.png"
             alt="">
    </button>
    <div class="footer__balance">WINNINGS:
        <span [class.is-blurred]="!isUserLogged()">${{getWinnings() | number: '1.0-0'}}</span>
    </div>

</a>
